import { useEffect, useRef, useState } from 'react';
import './styles/global.css';

import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Education from './components/Education';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const cursorRef = useRef(null);
  const ringRef = useRef(null);
  const [isHover, setIsHover] = useState(false);
  const rafRef = useRef(null);
  const ringPos = useRef({ x: 0, y: 0 });
  const mousePos = useRef({ x: 0, y: 0 });

  // Scroll progress bar
  const [scrollPct, setScrollPct] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const pct = window.scrollY / (document.body.scrollHeight - window.innerHeight);
      setScrollPct(Math.min(pct * 100, 100));
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Custom cursor
  useEffect(() => {
    const onMove = (e) => {
      mousePos.current = { x: e.clientX, y: e.clientY };
      if (cursorRef.current) {
        cursorRef.current.style.left = e.clientX + 'px';
        cursorRef.current.style.top = e.clientY + 'px';
      }
    };
    window.addEventListener('mousemove', onMove);

    const animate = () => {
      const { x: rx, y: ry } = ringPos.current;
      const { x: mx, y: my } = mousePos.current;
      const nx = rx + (mx - rx) * 0.12;
      const ny = ry + (my - ry) * 0.12;
      ringPos.current = { x: nx, y: ny };
      if (ringRef.current) {
        ringRef.current.style.left = nx + 'px';
        ringRef.current.style.top = ny + 'px';
      }
      rafRef.current = requestAnimationFrame(animate);
    };
    rafRef.current = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(rafRef.current);
    };
  }, []);

  // Hover detection
  useEffect(() => {
    const enter = () => setIsHover(true);
    const leave = () => setIsHover(false);
    const els = document.querySelectorAll('a, button');
    els.forEach(el => { el.addEventListener('mouseenter', enter); el.addEventListener('mouseleave', leave); });
    return () => els.forEach(el => { el.removeEventListener('mouseenter', enter); el.removeEventListener('mouseleave', leave); });
  });

  return (
    <>
      {/* Scroll progress */}
      <div className="progress-bar" style={{ width: scrollPct + '%' }} />

      {/* Custom cursor */}
      <div
        ref={cursorRef}
        className={`cursor ${isHover ? 'cursor--hover' : ''}`}
      />
      <div
        ref={ringRef}
        className={`cursor-ring ${isHover ? 'cursor-ring--hover' : ''}`}
      />

      {/* Site */}
      <Navigation />
      <main>
        <Hero />
        <div style={{ height: 1, background: 'var(--border)', maxWidth: '100%' }} />
        <About />
        <div style={{ height: 1, background: 'var(--border)' }} />
        <Skills />
        <div style={{ height: 1, background: 'var(--border)' }} />
        <Experience />
        <div style={{ height: 1, background: 'var(--border)' }} />
        <Projects />
        <div style={{ height: 1, background: 'var(--border)' }} />
        <Education />
        <div style={{ height: 1, background: 'var(--border)' }} />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
